/**
 * Normalize learning outcomes payloads from various AI response shapes
 * (outcomes[].statement, core_learning_outcomes[].outcome, etc.)
 */
export function normalizeLearningOutcomesData(data) {
  if (!data || typeof data !== 'object') return data;

  const rawOutcomes =
    Array.isArray(data.outcomes) && data.outcomes.length
      ? data.outcomes
      : Array.isArray(data.core_learning_outcomes)
        ? data.core_learning_outcomes
        : Array.isArray(data.learning_outcomes)
          ? data.learning_outcomes
          : [];

  const outcomes = rawOutcomes
    .map((outcome, idx) => {
      if (!outcome || typeof outcome !== 'object') return null;
      const statement = String(
        outcome.statement ||
          outcome.outcome ||
          outcome.learning_outcome ||
          outcome.title ||
          outcome.description ||
          outcome.text ||
          ''
      ).trim();
      if (!statement) return null;
      return {
        ...outcome,
        id: outcome.id || outcome.code || `LO-${idx + 1}`,
        type: outcome.type || 'SpecificOutcome',
        statement,
        bloom_level: outcome.bloom_level || outcome.bloom || 'Apply'
      };
    })
    .filter(Boolean);

  if (!outcomes.length) return data;

  return {
    ...data,
    outcomes,
    outcome_type:
      data.outcome_type === 'unknown' || !data.outcome_type
        ? 'learning_outcome'
        : data.outcome_type
  };
}

export function hasValidLearningOutcomes(data) {
  const normalized = normalizeLearningOutcomesData(data);
  return (
    Array.isArray(normalized?.outcomes) &&
    normalized.outcomes.some((o) => o.statement && o.statement.trim().length > 0)
  );
}

export function countLearningOutcomes(data) {
  const normalized = normalizeLearningOutcomesData(data);
  return normalized?.outcomes?.length || 0;
}
